import { mapState, mapGetters, mapActions } from 'vuex'

// auth service
export const authComputed = {
    ...mapState('auth', {
        authToken: state => state.authToken,
        userUuid: state => state.userUuid,
    }),
    ...mapGetters('auth', ['loggedIn', 'userUuid']),
}

export const authMethods = {
    ...mapActions('auth', ['logIn', 'logOut', 'setAuth']),
}

// language service
export const languageComputed = {
    ...mapGetters('language', ['languages', 'appLanguage']),
}

export const languageMethods = {
    ...mapActions('language', ['setLanguages', 'setAppLanguage']),
}

// project service
export const projectComputed = {
    ...mapGetters('project', [
        'project',
        'isOwner',
        'isTranslator',
        'isDeveloper',
        'isAdmin',
    ]),
}

export const projectMethods = {
    ...mapActions('project', ['setProject']),
}

// resources service
export const resourcesComputed = {
    ...mapGetters('resources', ['tags', 'resources', 'addedGoogleDoc']),
}
export const resourcesMethods = {
    ...mapActions('resources', ['setTags', 'setResources', 'setAddedGoogleDoc']),
}

// notifications
export const notificationsComputed = {
    ...mapGetters('notifications', ['error', 'info']),
}

export const notificationsMethods = {
    ...mapActions('notifications', ['setError', 'setInfo']),
}

// user
export const userComputed = {
    ...mapGetters('user', ['user', 'mainPageAsCard']),
}
export const userMethods = {
    ...mapActions('user', ['setProfile', 'getProfile', 'setMainPageAsCard']),
}

// current language

// pages states
export const pageStateComputed = {
    ...mapGetters('pages', ['translationPageState', 'translationByDayStatPageState']),
}
export const pageStateMethods = {
    ...mapActions('pages', ['setTranslationPageState', 'setTranslationByDayStatPageState']),
}
